export default "__VITE_ASSET__DCRksV0Z__"